import { IAppConfigWithRequestedBUIDKeys } from '~domain/entities/IConfig';
import { ConfigRepository } from '~repositories/ConfigRepository';
import { diContainer, serviceNames } from '~setup/diContainer';

export class AccountServiceStartedUseCase {
    private configRepository: ConfigRepository;
    private configs: IAppConfigWithRequestedBUIDKeys;

    constructor(configs: IAppConfigWithRequestedBUIDKeys) {
        this.configRepository = diContainer.get(serviceNames.configRepository);
        this.configs = configs;
    }

    public execute = async () => {
        await this.configRepository.fetchConfigs(this.configs);
    };
}
